const CwsfLobby = () => import(/* webpackChunkName: "CwsfLobby" */ '@/components/Pages/Lobby/CwsfLobby')
const Regions = () => import(/* webpackChunkName: "PageRegions" */ '@/components/Pages/Regions')
const YearlyPage = () => import(/* webpackChunkName: "PageYearlyPage" */ '@/components/Pages/YearlyPage')
const YscExpoBooth = () => import(/* webpackChunkName: "YscExpoBooth" */ '@/components/Pages/YscExpoBooth')
const WixUrl = () => import(/* webpackChunkName: "WixUrl" */ '@/components/Pages/IframeUrl')
const Auditorium = () => import(/* webpackChunkName: "PageAuditorium" */ '@/components/Pages/Auditorium')
// const YSC2020 = () => import(/* webpackChunkName: "PageYSC" */ '@/components/Pages/LandingPage/YSC2020')
const YscExpoBooth2022 = () => import(/* webpackChunkName: "YscExpoBooth2022" */ '@/components/Pages/YscExpoBooth2022')
const Ysc2022ActivitiesAndResources = () => import(/* webpackChunkName: "Ysc2022ActivitiesAndResources" */ '@/components/Pages/Ysc2022ActivitiesAndResources')
const Home = () => import(/* webpackChunkName: "SectionHome" */ '@/components/Base/SectionHome')

const store = require('@/store').default

module.exports = [
  {
    path: '/:partner?/cwsf-espc',
    name: 'cwsflobby',
    component: CwsfLobby
  },
  {
    path: '/:partner?/region/:regionNameParam?/:year?',
    name: 'region',
    component: Regions,
    props: true
  },
  {
    path: '/national/:year',
    name: 'national',
    component: YearlyPage
  },
  {
    path: '/:partner?/:regionname?-fr',
    name: 'regionsFrench',
    component: WixUrl
  },
  {
    path: '/:partner?/:regionname?-en',
    name: 'regionsEnglish',
    component: WixUrl
  },
  {
    path: '/:partner?/expobooth/:id',
    name: 'expobooth',
    component: YscExpoBooth
  },
  {
    path: '/:partner?/stem-expo',
    alias: '/stem-expo',
    redirect: { path: '/' }
    // component: ViewAll
    // beforeEnter: (to, from, next) => {
    //   if (auth.isLoggedIn()) {
    //     next()
    //   } else {
    //     next({ name: 'home' })
    //   }
    // }
  },
  {
    path: '/:partner?/auditorium',
    name: 'auditorium',
    component: Auditorium
  },
  {
    path: '/:partner?/cwsf-tv',
    name: 'cswftv',
    component: Auditorium
  },
  {
    path: '/:partner?/activities',
    name: 'Ysc2022ActivitiesAndResources',
    component: Ysc2022ActivitiesAndResources
  },
  // {
  //   path: '/:partner?/ysc2020',
  //   name: 'ysc2020',
  //   component: YSC2020
  // },
  {
    path: '/:partner?/expobooth/:id',
    name: 'expobooth22',
    component: YscExpoBooth2022
  },
  {
    path: '/:partner?/:fairSlug',
    name: 'exploreFair',
    component: Home,
    beforeEnter: function (to, from, next) {
      if (to.params.fairSlug !== 'undefined') {
        store.dispatch('setPage', to.params.fairSlug)
        store.dispatch('getFairForEvent', store.getters.currentPage)
          .then(() => {
            next()
          })
          .catch(err => {
            console.error(err)
            store.dispatch('getIframeBySlug', `/${to.params.fairSlug}`).then(iframe => {
              next({ name: 'iframe', params: { iframeSlug: iframe.route.replace(/^\/+/, '') } })
            }).catch(err => {
              console.error(err)
              next({ name: 'notFound' })
            })
          })
      }
    }
  },
  {
    path: '/:partner?/:iframeSlug',
    name: 'iframe',
    component: WixUrl
  },
  {
    path: '/:partner?/faq',
    name: 'faq',
    component: WixUrl,
    meta: { fixedToolbar: true }
  }
]
